import moment from "moment/moment";
import api from "./apiURL";

export async function getServiceVisits() {
  const today = moment().format("YYYY-MM-DD");
  try {
    //  const response = await api.get(`api/v1/admin/visit/today/?date=2025-02-16`);
    const response = await api.get(`api/v1/admin/visit/today/?date=${today}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function visitActions(data) {
  try {
    const response = await api.put(`api/v1/admin/visit/action`, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getContactNumber(id) {
  try {
    const response = await api.get(`api/v1/admin/user/call/?id=${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function permitRemainingDays(data) {
  try {
    const response = await api.put(`api/v1/admin/visit/cancel/day `, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function paymentRefund(data) {
  try {
    const response = await api.put(`/api/v1/admin/visit/refund`, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function visitPayout(data) {
  try {
    const response = await api.put(`/api/v1/admin/visit/payout`, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}
